<template>
  <div id="app" class="d-flex flex-column h-100">
    <header>
      <Header></Header>
    </header>
    <main role="main" class="flex-shrink-0 mt-5">
      <div class="container">
        <router-view />
        <Shop v-if="showShop" :hubId="hubId" :currentScent="currentScent" />
      </div>
    </main>
    <footer class="footer mt-auto py-3">
      <Footer></Footer>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Shop from '@/components/Shop.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import { mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Shop,
  },
  data() {
    return {
      showShop: false,
      hubId: 0,
      currentScent: 'No scent',
    };
  },
  created() {
    this.getScents().then(() => {
      console.info('loaded scents');
    });
  },
  mounted() {
    this.$root.$on('open', this.open);
    this.$root.$on('close', this.close);
  },
  methods: {
    ...mapActions({
      getScents: 'scents/getScents',
    }),
    close() {
      this.showShop = false;
    },
    open(hubId, scent) {
      this.hubId = hubId ? hubId : 0;
      this.currentScent = scent;
      this.showShop = true;
    },
  },
};
</script>
